










import { defineComponent, PropType } from '@nuxtjs/composition-api';
import UCIcon from '@shared/components/@atoms/UCIcon/UCIcon.vue';

export default defineComponent({
  name: 'UCBadge',
  components: {
    UCIcon,
  },
  props: {
    icon: {
      type: String,
      default: null,
    },
    color: {
      type: String as PropType<'info' | 'warn' | 'success' | 'danger' | ''>,
      default: '',
    },
    count: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    iconColor(): string {
      switch (this.color) {
        case 'info':
          return '#0279e7';
        case 'danger':
          return 'var(--c-support-50)';
        case 'warn':
          return 'var(--c-support-100)';
        case 'success':
          return 'var(--c-support-200)';
        default:
          return 'var(--c-primary-500)';
      }
    },
  },
});
